import React from "react";

import { Modal } from "antd";
import {
  HelpTitle,
  HelpSection,
  HelpText,
  Button,
  ModalContainer,
  ImportantInfo,
} from "./styles";

interface TwygoInfoModalProps {
  isVisible: boolean;
  onClose: () => void;
}

const TwygoInfoModal: React.FC<TwygoInfoModalProps> = ({
  isVisible,
  onClose,
}) => {
  return (
    <Modal
      title="Ajuda - Integração com a Twygo"
      visible={isVisible}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose} actionType="default">
          Fechar
        </Button>,
      ]}
      width={800}
    >
      <ModalContainer>
        <ImportantInfo>
          <strong>IMPORTANTE:</strong> Sempre utilize nossa plataforma para
          gerenciar usuários na Twygo. Isso garante a sincronização correta dos
          dados e mantém a integridade da integração entre os sistemas.
        </ImportantInfo>

        <HelpSection>
          <HelpTitle>Filtros</HelpTitle>
          <HelpText>
            <strong>Busca por nome ou email:</strong> Digite para filtrar
            usuários pelo nome ou email.
            <br />
            <strong>Filtro por status:</strong> Selecione para filtrar usuários
            por status (Ativos, Inativos ou Não Cadastrados).
            <br />
            <strong>Filtro por loja:</strong> Selecione uma loja para mostrar
            apenas os usuários vinculados a ela.
            <br />
            <strong>Filtro por cargo:</strong> Selecione para filtrar usuários
            pelo cargo/perfil associado.
            <br />
            <strong>Filtro por nível:</strong> Selecione para filtrar usuários
            pelo nível de acesso (Master, Geral, Administrador, Proprietário,
            Usuário básico).
          </HelpText>
        </HelpSection>

        <HelpSection>
          <HelpTitle>Ações em Massa</HelpTitle>
          <HelpText>
            <strong>Seleção:</strong> Use as caixas de seleção para escolher
            usuários com base em seu status.
            <br />
            <strong>Enviar para Twygo:</strong> Envia os usuários selecionados
            que ainda não foram cadastrados na Twygo.
            <br />
            <strong>Inativar Usuários:</strong> Inativa os usuários selecionados
            que estão ativos na Twygo.
            <br />
            <strong>Ativar Usuários:</strong> Ativa os usuários selecionados que
            estão inativos na Twygo.
            <br />
            <strong>Vincular Cursos em Massa:</strong> Permite vincular cursos a
            vários usuários ativos na Twygo ao mesmo tempo.
            <br />
            <strong>Atualizar Magic Links:</strong> Atualiza o Magic Link para
            usuários ativos na Twygo que não têm Magic Link configurado. Apenas
            usuários com status ATIVO são considerados nesta operação. Este
            botão fica desabilitado quando não há usuários ativos que necessitam
            desta atualização.
          </HelpText>
        </HelpSection>

        <HelpSection>
          <HelpTitle>Tabela de Usuários</HelpTitle>
          <HelpText>
            <strong>Seleção individual:</strong> Selecione usuários
            individualmente marcando as caixas.
            <br />
            <strong>Ações por usuário:</strong> Cada linha possui botões para
            ações individuais:
            <br />- <strong>Enviar para Twygo:</strong> Cadastra o usuário na
            plataforma Twygo.
            <br />- <strong>Inativar/Ativar:</strong> Altera o status do usuário
            na Twygo.
            <br />- <strong>Ver Cursos:</strong> Abre uma janela para visualizar
            os cursos vinculados ao usuário e adicionar novos cursos. Este botão
            fica disponível apenas para usuários já cadastrados e ativos na
            Twygo.
          </HelpText>
        </HelpSection>

        <HelpSection>
          <HelpTitle>Gerenciamento de Cursos</HelpTitle>
          <HelpText>
            <strong>Visualização dos Cursos:</strong> Os cursos são exibidos em
            uma lista expansível, onde você pode clicar em qualquer parte do
            item para expandir e ver mais detalhes.
            <br />
            <strong>Status do Curso:</strong> O status de cada curso é indicado
            por cores:
            <br />-{" "}
            <span style={{ color: "#faad14" }}>Não Iniciado (laranja)</span>:
            Quando o progresso é 0%.
            <br />-{" "}
            <span style={{ color: "#1890ff" }}>Em Andamento (azul)</span>:
            Quando o progresso está entre 1% e 99%.
            <br />- <span style={{ color: "#52c41a" }}>Completo (verde)</span>:
            Quando o progresso atingiu 100%.
            <br />
            <strong>Barra de Progresso:</strong> Cada curso mostra uma barra
            visual do progresso atual do usuário.
            <br />
            <strong>Detalhes do Curso:</strong> Ao expandir um curso, você verá
            informações detalhadas como progresso percentual e data/hora do
            último acesso.
            <br />
            <strong>Vinculação de Cursos:</strong> Na aba "Cursos Disponíveis",
            você pode selecionar um ou mais cursos para vincular ao usuário.
            Após selecionar os cursos desejados, clique em "Vincular Cursos
            Selecionados" para concluir a operação.
          </HelpText>
        </HelpSection>
      </ModalContainer>
    </Modal>
  );
};

export default TwygoInfoModal;
